import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

const initialState = {
  items: [],
  loading: false,
  error: null,
};

export const fetchConstituenciesTypes = createAsyncThunk('constituenciesType/fetchAll', async () => {
  const response = await api.get('/constituencies-type');
  if (response.data && Array.isArray(response.data.data)) {
    return response.data.data;
  }
  if (Array.isArray(response.data)) {
    return response.data;
  }
  throw new Error('Unexpected data format');
});

export const createConstituenciesType = createAsyncThunk('constituenciesType/create', async (data) => {
  const response = await api.post('/constituencies-type', data);
  return response.data.data;
});

export const updateConstituenciesType = createAsyncThunk('constituenciesType/update', async ({ id, ...data }) => {
  const response = await api.put(`/constituencies-type/${id}`, data);
  return response.data.data;
});

export const deleteConstituenciesType = createAsyncThunk('constituenciesType/delete', async (id) => {
  await api.delete(`/constituencies-type/${id}`);
  return id;
});

const constituenciesTypeSlice = createSlice({
  name: 'constituenciesType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConstituenciesTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConstituenciesTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchConstituenciesTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch constituencies types';
      })
      .addCase(createConstituenciesType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createConstituenciesType.fulfilled, (state, action) => {
        state.loading = false;
        state.items.push(action.payload);
      })
      .addCase(createConstituenciesType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to create constituencies type';
      })
      .addCase(updateConstituenciesType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateConstituenciesType.fulfilled, (state, action) => {
        state.loading = false;
        const idx = state.items.findIndex((item) => item.id === action.payload.id);
        if (idx !== -1) state.items[idx] = action.payload;
      })
      .addCase(updateConstituenciesType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to update constituencies type';
      })
      .addCase(deleteConstituenciesType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteConstituenciesType.fulfilled, (state, action) => {
        state.loading = false;
        state.items = state.items.filter((item) => item.id !== action.payload);
      })
      .addCase(deleteConstituenciesType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to delete constituencies type';
      });
  },
});

export default constituenciesTypeSlice.reducer; 